
export function getRandomBackgroundColor() {
  return `hsl(${Math.floor(Math.random() * 256)}, 30%, 75%)`;
};